/**
 * Auth answers as the app holds them. See docs/rules/api_boundary.md.
 */

import type { MeResponse, MeResponseDto } from '@/types/auth';
import { MeResponseDtoSchema } from '@/types/auth';

/** Go spells an empty list `null` or leaves it out, and leaves out a false flag. */
export function toMe(dto: MeResponseDto): MeResponse {
    return {
        ...dto,
        orgs: dto.orgs ?? [],
        pendingInvites: dto.pendingInvites ?? [],
        platformAdmin: dto.platformAdmin ?? false,
    };
}

export const MeResponseSchema = MeResponseDtoSchema.transform(toMe);
